export const CONTACT_ITEMS = ["email", "phone", "location", "bank"];
export const KEYWORDS = ["Arvutiabi", "Arvutite hooldus", "Arvutite müük", "Arvutite parandus", "Tallinnas ja Keilas"];
export const COMPANY = "Nutikas OÜ";
export const REGISTRY_CODE = "Registrikood: 12192364";
export const KMKR = "KMKR nr: EE101495556";
export const COPYRIGHT = "© Nutikas OÜ - kõik õigused kaitstud";